import React from 'react';
import { Row, Col } from 'antd';
import Button from '../../../../components/Button';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import emptyCpayImage from '../../../../img/cpay-svg/empty.svg';
import emptyNFGImage from '../../../../img/nfgpay-svg/empty-nfg.svg';
import emptyFinvaroImage from '../../../../img/finvaro/empty-finvaro.svg';
import emptyClarniumImage from '../../../../img/clarnium/empty-clarnium.svg';
import emptyInexImage from '../../../../img/inex/empty-inex.svg';
import emptyInstaImage from '../../../../img/instaXchange/empty-insta.svg';
import emptyCoineraImage from '../../../../img/coinera/empty-coinera.svg';
import Transaction from '../Transaction';
import { identity } from '../../../../utils/getIdentity';
import formatCurrency from "../../../../utils/currencyFormatter";
import { useTranslation } from "react-i18next";


const emptyImage = {
  cpay: emptyCpayImage,
  nfg: emptyNFGImage,
  finvaro: emptyFinvaroImage,
  clarnium: emptyClarniumImage,
  inex: emptyInexImage,
  insta: emptyInstaImage,
  coinera: emptyCoineraImage
}

const UserTransactionsMarkUpList = ({
  arrayData,
  fetchingFlag,
  countItem,
  totalOperations,
  totalUsdVolume,
  isFromTransactionsByUser,
  moreTransactionsFetching,
  handleLoadMoreClick,
  fetchingMoreTransactionsByUser,
  userSearchParams,
  userName
}) => {
  const { t } = useTranslation();
  return (
    <>
      {!fetchingFlag ? (
        <>
          {!!totalOperations && (
            <div>
              <span className="fee-transactions__total">{t('admin.total_operations')}:</span> {totalOperations}
            </div>
          )}
          {!!totalUsdVolume && (
            <div>
              <span className="fee-transactions__total">{t('admin.total_usd_volume')}:</span> {formatCurrency(totalUsdVolume)}
            </div>
          )}
          {arrayData?.length ? (
            <Row className="fee-transactions__legend">
              {isFromTransactionsByUser && <Col span={5}>{t('admin.profile')}</Col>}
              <Col span={!isFromTransactionsByUser ? 1 : 5}>{t('admin.type')}</Col>
              <Col span={!isFromTransactionsByUser ? 4 : 0}></Col>
              <Col span={!isFromTransactionsByUser ? 5 : 0}>{t('admin.email')}</Col>
              <Col span={!isFromTransactionsByUser ? 5 : 5}>
                {t('admin.data_time')}
              </Col>
              <Col span={2}>{t('admin.status')}</Col>
              <Col span={7} className="fee-transactions__legend-amount">
                {t('admin.amount')}
              </Col>
            </Row>
          ) : null}
          <div className="fee-transactions-list">
            {arrayData?.length ? (
              arrayData.map(transaction => <Transaction key={transaction._id} transaction={transaction} isFromTransactionsByUser={isFromTransactionsByUser} userSearchParams={userSearchParams} userName={userName}/>)
            ) : (
              <div className="fee-transactions-list__empty">
                <span className="fee-transactions-list__empty-title">{t('admin.transactions_will_show')}</span>
                <img src={emptyImage[identity]} className="fee-transactions-list__empty-image" alt="empty" />
              </div>
            )}
          </div>
          {arrayData?.length && arrayData.length < countItem ? (
            <>
              <Button
                type="button"
                className={`fee-transactions__load-more fee-transactions__load-more-${identity}`}
                loading={!isFromTransactionsByUser ? moreTransactionsFetching : fetchingMoreTransactionsByUser}
                onClick={handleLoadMoreClick}
              >
                {t('admin.load_more')}
              </Button>
            </>
          ) : null}
        </>
      ) : (
        <div className="fee-transactions__loader">
          <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} />
        </div>
      )}
    </>
  );
};

export default UserTransactionsMarkUpList;
